export enum PaymentModel
{
    Subscription = 1, // Credit card
    OneTime = 2 // Betalingsservice
}
